import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import {Button, LinearProgress, MenuItem} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Title} from 'components/forms';
import CustomAlert from 'components/grid-dx/alert';
import {i18n2} from 'features/i18n/i18n';
import {FastField, Field, Form, Formik} from 'formik';
import {TextField} from 'formik-material-ui';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import useAddContent from '../hooks/useAddContent';
import {ContentSchema} from '../model/Content';
import AddLink from './addLink';
import AddPDF from './DropZone';
import MediaSelect from './MediaSelect';

const CreateContentPopup = ({
  open,
  setOpen,
  handleClose,
  row,
  remoteUpdate,
  refresh,
}) => {
  const MAX_FILE_SIZE_MB = 100;
  const user = useSelector((state) => state.authentication.user.name);
  const [message, setMessage] = React.useState({
    text: '',
    open: false,
    successful: false,
  });
  const addContent = useAddContent();
  let timeout;
  // eslint-disable-next-line no-unused-vars
  const [idCourse, setIdCourse] = React.useState(
    useSelector((x) => x.courseReducer.id),
  );

  const [isEditing, setIsEditing] = React.useState(false);
  const [initialValues, setInitialValues] = React.useState({
    iD_Course: idCourse,
    type: '',
    title: '',
    description: '',
    reason: '',
    pass: '',
    user: user,
  });

  //Este submit esta mal...
  const submit = async (values, formikBag) => {
    if (row != null) {
      const editingOptions = {
        row: row,
        changed: values,
      };

      try {
        const response = await remoteUpdate(editingOptions);
        if (response.ok) {
          setMessage({
            text: i18n2._('Editador correctamente'),
            open: true,
            successful: true,
          });
          timeout = setTimeout(() => {
            handleClose();
            // setActiveChoice(idCourse, data);
            refresh();
          }, 1000);
        } else {
          formikBag.setSubmitting(false);
          if (response.status === 413) {
            setMessage({
              text: i18n2._(
                'El archivo supera el tamano maximo permitido (100 MB).',
              ),
              open: true,
              successful: false,
            });
            return;
          }
          response
            .text()
            .then((message) => setMessage({text: message, open: true}));
        }
      } catch (error) {
        return console.log(error);
      }
    } else {
      let addingOptions = {
        added: values,
      };
      try {
        const response = await addContent(addingOptions);
        if (response.ok) {
          response.json().then((data) => {
            setMessage({
              text: i18n2._('Creado correctamente'),
              open: true,
              successful: true,
            });
            // eslint-disable-next-line no-unused-vars
            timeout = setTimeout(() => {
              handleClose();
              // setActiveChoice(idCourse, data);
              refresh();
            }, 1000);
          });
        } else {
          formikBag.setSubmitting(false);
          if (response.status === 413) {
            setMessage({
              text: i18n2._(
                'El archivo supera el tamano maximo permitido (100 MB).',
              ),
              open: true,
              successful: false,
            });
            return;
          }
          response
            .text()
            .then((message) =>
              setMessage({text: message, open: true, successful: false}),
            );
        }
      } catch (error) {
        return console.log(error);
      }
    }
  };

  const getMediaQuery = () => {
    const url = '/CourseManager/GetCourseMedia';
    return (
      url +
      `?ID=${row.medias[0].iD_Media}&ID_Content=${row.iD_Content}&ID_Course=${row.iD_Course}`
    );
  };

  const renderAdd = (type, setFieldValue, isEditing, pdfName) => {
    switch (type) {
      case 0:
        return <AddLink />;
      case 1:
        return (
          <AddPDF
            setFieldValue={setFieldValue}
            isEditing={isEditing}
            pdfName={pdfName}
            extension={'PDF'}
            maxFileSizeBytes={MAX_FILE_SIZE_MB * 1024 * 1024}
          />
        );
      case 3:
        return (
          <MediaSelect
            setFieldValue={setFieldValue}
            isEditing={isEditing}
            pdfName={pdfName}
            extension="multimedia"
            urlMedia={isEditing ? getMediaQuery() : null}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (row != null) {
      setInitialValues({
        iD_Course: row.iD_Course,
        iD_Content: row.iD_Content,
        type: row.type,
        title: row.title,
        description: row.description,
        name:
          row.pdFs.length > 0
            ? row.pdFs[0].name
            : row.medias.length > 0
              ? row.medias[0].name
              : '',
        iD_PDF: row.pdFs.length > 0 ? row.pdFs[0].iD_PDF : '',
        iD_Media: row.medias.length > 0 ? row.medias[0].iD_Media : '',
        iD_Link: row.links.length > 0 ? row.links[0].iD_Link : '',
        url: row.links.length > 0 ? row.links[0].url : '',
        reason: '',
        pass: '',
        user: user,
      });
      setIsEditing(true);
    } else {
      setInitialValues({
        iD_Course: idCourse,
        type: '',
        title: '',
        description: '',
        reason: '',
        pass: '',
        user: user,
      });
      setIsEditing(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row]);

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        scroll="body"
        maxWidth="md"
        fullWidth={true}
        onClose={handleClose}>
        <Title onClose={handleClose} title={'Material'} />
        <DialogContent>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              onSubmit={submit}
              validationSchema={ContentSchema()}>
              {(formikProps) => {
                return (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item md={12} xs={12}>
                        <Field
                          name="type"
                          component={TextField}
                          select
                          required
                          label={i18n2._('Tipo')}
                          fullWidth
                          variant="outlined"
                          disabled={row ? true : false}>
                          <MenuItem value={0}>Link</MenuItem>
                          <MenuItem value={1}>PDF</MenuItem>
                          <MenuItem value={2}>Choice</MenuItem>
                          <MenuItem value={3}>Media</MenuItem>
                        </Field>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          name="title"
                          component={TextField}
                          required
                          label={i18n2._('Título')}
                          fullWidth
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          name="description"
                          required
                          component={TextField}
                          label={i18n2._('Descripción')}
                          autoFocus
                          fullWidth
                          variant="outlined"
                        />
                      </Grid>
                      {renderAdd(
                        formikProps.values.type,
                        formikProps.setFieldValue,
                        isEditing,
                        formikProps.values.name ? formikProps.values.name : '',
                      )}
                      <Grid item xs={12}>
                        <Field
                          label={i18n2._('Reason')}
                          name={'reason'}
                          fullWidth
                          variant="outlined"
                          component={TextField}
                          multiline
                        />
                      </Grid>
                      <Grid item sm={6} xs={12} style={{padding: 20}}>
                        <Field
                          label={i18n2._('User')}
                          name={'user'}
                          variant="standard"
                          size="small"
                          fullWidth
                          component={TextField}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled={true}
                        />
                      </Grid>
                      <Grid item sm={6} xs={12} style={{padding: 20}}>
                        <FastField
                          label={i18n2._('Password')}
                          name={'pass'}
                          variant="standard"
                          size="small"
                          fullWidth
                          component={TextField}
                          type="password"
                          validate={(value) => {
                            let error;
                            if (
                              typeof value !== 'undefined' &&
                              value.length === 0
                            ) {
                              error = i18n2._('Please provide a password');
                            }
                            return error;
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      {formikProps.isSubmitting && <LinearProgress />}
                      <Grid item xs={12}>
                        <div style={{float: 'right', marginBottom: '10px'}}>
                          <Button
                            onClick={() => handleClose()}
                            className="red-text">
                            {i18n2._('Cancelar')}
                          </Button>
                          <Button
                            type="submit"
                            disabled={formikProps.isSubmitting}
                            variant="contained"
                            color="primary">
                            {row ? <Trans>Editar</Trans> : <Trans>Crear</Trans>}
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </MuiPickersUtilsProvider>
        </DialogContent>
        <CustomAlert
          message={message.text}
          ms={1000}
          successful={message.successful}
          handleClose={() => setMessage((prev) => ({...prev, open: false}))}
          open={message.open}
        />
      </Dialog>
    </>
  );
};

export default CreateContentPopup;
